import { Card } from 'antd'
import { CompanyLogo } from './CompanyLogo'
import { CompanyDetails } from './CompanyDetails'
import { useCompanyStore } from '../../store/company/companyStore'

export const DocumentHeader = () => {
  const { settings } = useCompanyStore((state) => state.company)

  return (
    <Card
      className="mb-6 overflow-hidden bg-white"
      styles={{ body: { padding: 0 } }}
    >
      <div
        className="h-2"
        style={{
          background: `${settings.primaryColor}`
        }}
      />

      <div className="p-6">
        <div className="flex justify-between items-start gap-8 flex-col md:flex-row items-end md:items-start">
          <CompanyLogo />
          <CompanyDetails />
        </div>
      </div>
    </Card>
  )
}
